module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_50-Grey-a44252dedd600f4d651479eb0a9f1f74.png";